import React from "react";

const TakeoffListContext = React.createContext();

export default TakeoffListContext;